import type { RouteComponent, RouteRecordRaw } from 'vue-router';
import { helpPages } from '@/help/helpPages';

const pageComponents = import.meta.glob<RouteComponent>('../pages/help/**/*.vue', { import: 'default' });

/**
 * One route per page in the User Guide manifest. Who may open each page is decided by
 * `permissionGuard`, from the `helpPage` meta.
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/docs',
    redirect: '/docs/publisher',
  },
  ...helpPages.map((page): RouteRecordRaw => {
    const component = pageComponents[`../pages/help/${page.file}`];
    if (!component) {
      throw new Error(`Help page component not found: ${page.file}`);
    }

    return {
      path: page.path,
      component,
      name: page.name,
      meta: { helpPage: page },
    };
  }),
];

export default routes;
